import { storeToRefs } from 'pinia'
import { useRegionStore } from '@/stores/region'
import type { GetRegionsParams } from '@/domain/entities/region.entity'

export function useRegions() {
  const regionStore = useRegionStore()
  const { regions, pagination, loading, error, hasRegions, hasError } = storeToRefs(regionStore)

  return {
    regions,
    pagination,
    loading,
    error,
    hasRegions,
    hasError,
    fetchRegions: (params?: GetRegionsParams, append?: boolean) =>
      regionStore.fetchRegions(params, append),
    loadMore: regionStore.loadMore,
    reset: regionStore.reset,
    clearError: regionStore.clearError,
  }
}
